import { useMemo } from "react";

import { useGetCustomer } from "../api/customers";
import useAuthStore from "../stores/authStore";

export default function useAuthenticatedUserData() {
  const { data: customer } = useGetCustomer();
  const idTokenPayload = useAuthStore((s) => s.idTokenPayload);

  return useMemo(
    () => ({
      userDisplay: customer?.firstName || (idTokenPayload && idTokenPayload["cognito:username"]),
    }),
    [idTokenPayload, customer],
  );
}
